import React from 'react'

export const FinishMeetingLoader = () => {
  return (
    <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }}>
      <div className='d-flex flex-column align-items-center'>
        <div>Finishing the meeting...</div>
        <div className='small-medium'>It may take a few seconds</div>
      </div>
    </div>
  )
}
